import {
  BarChart3,
  Building2,
  DollarSign,
  LineChart,
  Megaphone,
  PieChart,
  Scale,
  Settings,
  Sparkles,
  Store,
  Users,
  Wrench,
} from "lucide-react";
import cortexLogo from "../../assets/logos/cortex/logo.svg";
import { SidebarItem } from "./SidebarItem";
import { SidebarSection } from "./SidebarSection";
import { UserFooter } from "./UserFooter";

export type AppPage = "financeiro" | "mesa" | "varejo" | "rh";

interface Props {
  onLogout: () => void;
  userIniciais: string;
  userNome: string;
  activePage: AppPage;
  onNavigate: (p: AppPage) => void;
}

export function Sidebar({ onLogout, userIniciais, userNome, activePage, onNavigate }: Props) {
  return (
    <aside className="w-60 bg-indra-azul-deep flex flex-col flex-shrink-0 border-r border-white/5">
      <div className="px-5 py-4 border-b border-white/10">
        <img src={cortexLogo} alt="Cortex" className="h-8" />
        <div className="text-[11px] text-white/50 mt-1 tracking-wide">by Indra Energia</div>
      </div>

      <nav className="flex-1 overflow-y-auto p-3">
        <SidebarSection title="Áreas">
          <SidebarItem
            label="Financeiro"
            icon={<DollarSign size={16} />}
            active={activePage === "financeiro"}
            onClick={() => onNavigate("financeiro")}
          />
          <SidebarItem label="Comercial" icon={<Users size={16} />} locked />
          <SidebarItem label="Marketing" icon={<Megaphone size={16} />} locked />
          <SidebarItem
            label="RH"
            icon={<Users size={16} />}
            active={activePage === "rh"}
            onClick={() => onNavigate("rh")}
          />
          <SidebarItem label="Jurídico" icon={<Scale size={16} />} locked />
        </SidebarSection>

        <SidebarSection title="Operações">
          <SidebarItem
            label="Mesa de Operações"
            icon={<LineChart size={16} />}
            active={activePage === "mesa"}
            onClick={() => onNavigate("mesa")}
          />
          <SidebarItem
            label="Varejo"
            icon={<Store size={16} />}
            active={activePage === "varejo"}
            onClick={() => onNavigate("varejo")}
          />
          <SidebarItem label="Back Office" icon={<Wrench size={16} />} locked />
        </SidebarSection>

        <SidebarSection title="Análise">
          <SidebarItem label="Visão consolidada" icon={<PieChart size={16} />} locked />
          <SidebarItem label="Agentes IA" icon={<Sparkles size={16} />} locked />
        </SidebarSection>

        <SidebarSection title="Sistema">
          <SidebarItem label="Configurações" icon={<Settings size={16} />} locked />
          <SidebarItem label="Unidades" icon={<Building2 size={16} />} locked />
          <SidebarItem label="Benchmarks" icon={<BarChart3 size={16} />} locked />
        </SidebarSection>
      </nav>

      <UserFooter
        iniciais={userIniciais}
        nome={userNome}
        role="Sócio"
        onLogout={onLogout}
      />
    </aside>
  );
}
